import React from "react";
import ReactDOM from "react-dom/client";
//import { BrowserRouter } from 'react-router-dom';
import App from "./App";
import "react-dom";
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById("root"));

//const app = express();
//const cors = require("cors");

//app.use(cors());

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
